export interface MenuItem {
  id?: string;
  route: string;
  icon: string;
  name: string;
  summary?: string;
  children: MenuItem[];
  permissionNames?: string[];
  type: 'page' | 'category';
}

export const ALL_ITEMS: MenuItem[] = [
  {
    route: '/route1',
    icon: 'fa-regular fa-house',
    name: 'Dashboard',
    permissionNames: [],
    children: [],
    type: 'page',
  },
  {
    name: 'Crypto Infrastructure',
    route: '/route10',
    icon: 'fa-regular  fa-layer-group',
    type: 'category',
    children: [
      {
        name: 'Blockchain',
        route: '/route15',
        icon: '',
        type: 'category',
        children: [
          {
            name: 'Currencies',
            icon: '',
            children: [],
            permissionNames: ['crypto_currency_view'],
            route: '/configuration/currencies',
            type: 'page',
          },
          {
            name: 'Networks',
            icon: '',
            route: '/crypto-settings/blockchain/network',
            type: 'page',
            permissionNames: ['crypto_currency_blockchain_network_view'],
            children: [],
          },
          {
            name: 'Network Currency',
            icon: '',
            route: '/crypto-settings/blockchain/network-currency',
            permissionNames: ['crypto_currency_blockchain_network_currency_view'],
            type: 'page',
            children: [],
          },
        ],
      },
      {
        name: 'Providers',
        route: '/route12',
        icon: '',
        type: 'category',
        children: [
          {
            name: 'Provider Wallets',
            icon: '',
            route: '/crypto-settings/wallet',
            type: 'page',
            permissionNames: ['crypto_currency_crypto_wallet_view'],
            children: [],
          },
          {
            name: 'Providers',
            icon: '',
            route: '/crypto-settings/provider',
            permissionNames: ['crypto_currency_crypto_provider_view'],
            type: 'page',
            children: [],
          },
          {
            name: 'Provider Accounts',
            icon: '',
            route: '/crypto-settings/provider-account',
            permissionNames: ['crypto_currency_crypto_provider_api_account_view'],
            type: 'page',
            children: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Transactions',
    route: '/route4',
    icon: 'far fa-server',
    type: 'category',
    children: [
      {
        name: 'Gateway',
        route: '/route4',
        icon: '',
        type: 'category',
        children: [
          {
            route: '/transactions/pay-in',
            icon: '',
            name: 'Pay-In',
            type: 'page',
            permissionNames: ['transaction_payin_view'],
            children: [],
          },
          {
            route: '/transactions/pay-out',
            icon: '',
            name: 'Pay-Out',
            type: 'page',
            permissionNames: ['transaction_payout_view'],
            children: [],
          },
        ],
      },
      {
        name: 'Terminal Owner',
        route: '/route49',
        icon: '',
        type: 'category',
        children: [
          {
            route: '/transactions/terminal-owner/deposit',
            icon: '',
            name: 'Deposit',
            type: 'page',
            permissionNames: ['crypto_admin_direct_deposit_transactions_list_view'],
            children: [],
          },
        ],
      },
    ],
  },
  {
    name: 'Wallets',
    route: '/route169',
    icon: 'fa-regular fa-wallet',
    type: 'category',
    children: [
      {
        name: 'Accounts',
        route: '/report/wallet/wallet',
        icon: '',
        children: [],
        type: 'page',
        permissionNames: ['wallet_view_list'],
      },
      {
        name: 'Balance History',
        route: '/report/wallet/transactions',
        icon: '',
        permissionNames: ['wallet_service_view_wallet_transactions'],
        type: 'page',
        children: [],
      },
    ],
  },
  {
    name: 'Addresses',
    route: '/route3',
    icon: 'fa-regular fa-location-dot',
    type: 'category',
    children: [
      {
        name: 'Gateway',
        route: '/wallet-address',
        icon: '',
        type: 'page',
        permissionNames: ['wallet_address_view'],
        children: [],
      },
      {
        name: 'Terminal Owner',
        route: '/addresses/terminal-owner',
        icon: '',
        type: 'page',
        permissionNames: ['crypto_admin_direct_deposit_addresses_list_view'],
        children: [],
      },
    ],
  },

  {
    name: 'Terminal Config',
    route: '/route5',
    icon: 'fa-regular fa-cog',
    type: 'category',
    children: [
      {
        route: '/merchant',
        icon: '',
        name: 'Merchant',
        type: 'page',
        permissionNames: ['pg_merchant_view'],
        children: [],
      },
      {
        route: '/route7',
        icon: '',
        name: 'Terminal',
        type: 'category',
        children: [
          {
            route: '/terminal-cgpay',
            icon: '',
            name: 'CGPay',
            type: 'page',
            permissionNames: ['cgpay_terminal_view'],
            children: [],
          },
          {
            route: '/terminal-customer',
            icon: '',
            name: 'Terminal Customer',
            type: 'page',
            permissionNames: ['pay_terminal_customer_view'],
            children: [],
          },
          {
            route: '/terminal-add-deduct',
            icon: '',
            name: 'Terminal Add/Deduct',
            type: 'page',
            permissionNames: ['pg_terminal_add_deduct_view'],
            children: [],
          },
        ],
      },
      {
        name: 'Team Member',
        route: '/routes157',
        icon: '',
        type: 'category',
        children: [
          {
            name: 'Team Member Roles',
            icon: '',
            children: [],
            permissionNames: ['idp_view_role_team_member_list'],
            route: '/configuration/terminal/team-member-roles',
            type: 'page',
          },
        ],
      },
    ],
  },

  {
    type: 'category',
    name: 'Request',
    icon: 'fa-regular fa-file-lines',
    route: 'routes1512',
    children: [
      {
        name: 'Settlement',
        icon: '',
        route: '/request/settlement',
        type: 'page',
        permissionNames: ['settlement_view_request_list'],
        children: [],
      },
    ],
  },

  {
    route: '/route59',
    icon: 'fa-regular fa-user-gear',
    name: 'User Management',
    type: 'category',
    children: [
      {
        route: '/user-management/customer',
        icon: '',
        name: 'Customer',
        type: 'page',
        permissionNames: ['idp_view_customers'],
        children: [],
      },
      {
        route: '/route55',
        icon: '',
        name: 'Expert',
        type: 'category',
        children: [
          {
            route: '/user-management/expert/expert-management',
            icon: '',
            name: 'Expert List',
            type: 'page',
            permissionNames: ['idp_view_manager_list'],
            children: [],
          },
          {
            route: '/user-management/expert/role-management',
            icon: '',
            name: 'Roles Management ',
            type: 'page',
            permissionNames: ['idp_view_role_list'],
            children: [],
          },
        ],
      },
      {
        route: '/user-management/user-group',
        icon: '',
        name: 'User Group',
        permissionNames: ['idp_view_user_group_list'],
        type: 'page',
        children: [],
      },
    ],
  },
  {
    name: 'Finance',
    icon: 'fa-regular fa-building-columns',
    route: '/rot5',
    type: 'category',
    children: [
      {
        name: 'Wallet Balance',
        icon: '',
        route: '/finance/wallet-balance',
        type: 'page',
        children: [],
        permissionNames: ['wallet_view_balances'],
      },
      {
        name: 'Wallet Correction',
        icon: '',
        route: '/finance/wallet-correction',
        type: 'page',
        permissionNames: ['wallet_correction_request_view_list'],
        children: [],
      },
    ],
  },
  {
    name: 'Reports',
    route: '/route2',
    icon: 'far fa-chart-bar',
    type: 'category',
    children: [
      {
        route: '/reports/terminal-report',
        icon: '',
        name: 'Terminal Report',
        type: 'page',
        permissionNames: ['asset_view_user_terminal_wallet_report', 'terminals_transaction_report'],
        children: [],
      },
    ],
  },

  {
    route: '/route9',
    icon: 'fa-regular fa-code',
    name: 'Dev Space',
    type: 'category',
    children: [
      {
        route: 'dev-space/webhook-log',
        icon: '',
        name: 'Webhook Log',
        type: 'page',
        permissionNames: ['webhook_management_view'],
        children: [],
      },
      {
        route: 'dev-space/provider-webhook',
        icon: '',
        name: 'Provider Webhook',
        type: 'page',
        permissionNames: ['provider_webhook_view'],
        children: [],
      },
    ],
  },
];
